<template>
  <div>
            <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="true"
    >
    <table>
      <tr>
        <td>
          <div style="float: left">
            <h1>{{ translateWords.title }}</h1>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="200x"
            class="demo-ruleForm"
          >
            <table>
              <tr>
                <td>
                  <el-form-item
                    :label="translateWords.PositionName"
                    prop="PositionName"
                  >
                    <el-input v-model="ruleForm.PositionName"></el-input
                  ></el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item :label="translateWords.Status" prop="Status">
                    <el-select
                      v-model="ruleForm.Status"
                      :placeholder="translateWords.statusText"
                      filterable
                      style="width:400px"
                    >
                      <el-option
                        v-for="item in AddPositionStatusDropList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item
                    :label="translateWords.IsUseRegion"
                    prop="IsUseRegion"
                    style="width:300px"
                  >
                    <el-select    style="width:300px"
                      v-model="ruleForm.IsUseRegion"
                      :placeholder="translateWords.selectText"
                      filterable
                    >
                      <el-option
                        v-for="item in AddIsUseRegionDropList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
                <tr>
                <td>
                  <el-form-item
                    :label="translateWords.RegionName"
                    prop="RegionId"
                    style="width:300px"
                  >
                    <el-select    style="width:300px"
                      v-model="ruleForm.RegionId"
                      :placeholder="translateWords.regionText"
                      filterable
                    >
                      <el-option
                        v-for="item in AddRegionNameDropList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
            
            </table>
            <el-form-item style="float: left">
              <el-button type="primary" @click="submitForm('ruleForm')">{{
                translateWords.Save
              }}</el-button>
            </el-form-item>
          </el-form>
        </td>
      </tr>
    </table>
    </el-dialog>

    <table style="width:90%">
      <tr>
        <td>
          <div style="float: left">
            <h1>{{ translateWords.PostionManage }}</h1>
          </div>
        </td>
        <td></td>
      </tr>
      <tr>
                <td>
          {{ translateWords.DepartmentName }}：<el-select
            v-model="PositionQuery.DepartMentID"
            :placeholder="translateWords.DepartmentName"
          >
            <el-option
              v-for="item in DepartmentDropList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </td>
        <td>
          {{ translateWords.PositionName }}：<el-input
            style="width: 301px"
            v-model="PositionQuery.PositionName"
            :placeholder="translateWords.PositionName"
          ></el-input>
        </td>
        <td>
          {{ translateWords.RegionName }}：<el-select
            v-model="PositionQuery.RegionId"    style="width:300x"
            :placeholder="translateWords.regionText"
          >
            <el-option
              v-for="item in RegionNameDropList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </td>
      </tr>
      <tr>
          <td>
          {{ translateWords.Status }}：<el-select
            v-model="PositionQuery.Status"
            :placeholder="translateWords.Status"
          >
            <el-option
              v-for="item in PositionStatusDropList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </td>
         <td>
          {{ translateWords.RegionStatus }}：<el-select
            v-model="PositionQuery.RegionStatus"
            :placeholder="translateWords.RegionStatus"
          >
            <el-option
              v-for="item in RegionStatusDropList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </td>
         
        
             
        <td>
          <el-button type="primary" @click="query" v-if="PermissonList.Search.value">{{
            translateWords.query
          }}</el-button>
       
          <el-button type="primary" @click="add" v-if="PermissonList.Add.value">{{
            translateWords.add
          }}</el-button>
        </td>
      </tr>
    </table>


    <el-table :data="tableData" style="width:90%">
      <el-table-column prop="Id" :label="translateWords.Code"  width=101>
      </el-table-column>

 <el-table-column
        prop="DepartmentName"
        :label="translateWords.DepartmentName"
      >
      </el-table-column>
      <el-table-column
        prop="PositionName"
        :label="translateWords.PositionName"
      >
      </el-table-column>
       <el-table-column
        prop="RegionName"
        :label="translateWords.RegionName"
      >
      </el-table-column>
      <el-table-column   prop="IsUseRegion" :label="translateWords.IsUseRegion"  width="201">
      </el-table-column>
       <el-table-column  v-if="false"  prop="IsUseRegionCode" :label="translateWords.IsUseRegion">
      </el-table-column>
      <el-table-column  v-if="false"
        prop="RegionId" width="10"
        :label="translateWords.RegionName"
      >
      </el-table-column>
      <el-table-column 
        prop="Status"   width="200"
     
        :label="translateWords.Status"
      >
      </el-table-column>
       <el-table-column 
        prop="StatusCode" 
        v-if="false"
        :label="translateWords.Status"
      >
      </el-table-column>
      <el-table-column :label="translateWords.operate"  >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary" v-if="PermissonList.Update.value"
            @click="handleEdit(scope.$index, scope.row)"
            >{{ translateWords.edit }}</el-button
          >
          <el-button
            size="mini"
            type="primary" v-if="PermissonList.Delete.value"
            @click="handleDelete(scope.$index, scope.row)"
            >{{ translateWords.delete }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="1"
      :page-sizes="[10, 20, 30]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  
  </div>
</template>
<script>
import { importScript } from "../util/importScript";
import global from "./Global";
export default {
  name: "Position",
  data() {
    return {
      uid: this.$route.query.uid,
      token: this.$route.query.token,
      lang: this.$route.query.lang,
      total: 0,
      currPage: 1,
      pageSize: 10,
      isQuery: false,
      isEdit:false,
      tableData: [],
      PositionQuery: {
        PositionName: "",
        Status: '',
        RegionId: '',
        RegionStatus:'',
        DepartMentID:''
      },
      Id:0,
      RegionNameDropList: [],
      RegionStatusDropList:[],
      PositionStatusDropList: [],
      AddIsUseRegionDropList: [],
      AddPositionStatusDropList: [],
      AddRegionNameDropList:[],
      DepartmentDropList:[],
      dialogVisible:false,
      ruleForm: {
        PositionName: "",
        IsUseRegion: '', //启用
        RegionId: '', //请选择
        Status: ''//启用
      },
       rules: {
        PositionName: [{ required: true, message: "位置不能为空" }],
      },
     // PermissonList:{},
                     //ModuleCode:'OAS.PositionManageMenu',
                    //  PermissonList: {
                    //      Add: { key: 'OAS.PositionManageMenu.Add', value: false },
                    //      Delete: { key: 'OAS.PositionManageMenu.Delete', value: false },
                    //      Update: { key: 'OAS.PositionManageMenu.Update', value: false },
                    //      Search: { key: 'OAS.PositionManageMenu.Search', value: false }
                    //  },
      translateWords:{
            
              PositionName:"位置名称",
              RegionName:"区域名称",
              IsUseRegion:"区域状态",
              RegionStatus:"区域状态",
              PostionManage:"位置管理",
              Status:"位置状态",
              Code:'编码',
              query:'查询',
              operate:'操作',
              edit:'编辑',
              delete:'删除',
              DepartmentName:'所属国家',
              successText:'保存成功',
              failText:'保存失败',
              selectText:'请选择',
              statusText:'请选择状态',
              regionText:'请选择区域',
              loadFail: "加载下拉区域失败",
          loadRegionFail: "加载区域失败",
          loadRoomFail: "加载房间区域列表失败",
          delSuccess: "删除成功",
          delfailt: "删除失败",
          selectOneRegion: "请选择一个区域",
          title:'',
          Save:"保存",
          add:"新增位置"
      }
    };
  },
  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.jsT = window.jsT;
      that.translateWord();
    });
  },
  created: function () {
    this.PermissonList=  global.methods.GetOaRight(this.$store.state.PositionModuleCode,this.$store.state.PositionPermissonList,this.$route.query.token,this.$http,this.oarighturl)
    this.setInitStatus();
    this.getData(1, 10);
    this.getcountry();
  },
  methods: {
    translateWord() {
      let that = this;
      if (this.jsT) {
        //翻译词条，覆盖默认的
        this.translateWords = {
          RegionName:that.jsT.T(that.translateWords.RegionName), 
          PositionName: that.jsT.T(that.translateWords.PositionName), 
          IsUseRegion: that.jsT.T(that.translateWords.IsUseRegion),
          RegionStatus: that.jsT.T(that.translateWords.RegionStatus),
          PostionManage: that.jsT.T(that.translateWords.PostionManage),
          Status: that.jsT.T(that.translateWords.Status),
          Code: that.jsT.T(that.translateWords.Code),
          query: that.jsT.T(that.translateWords.query),
          operate: that.jsT.T(that.translateWords.operate),
          edit: that.jsT.T(that.translateWords.edit),
          delete: that.jsT.T(that.translateWords.delete),
          DepartmentName:that.jsT.T(that.translateWords.DepartmentName),
          //下面是方法中的词条
          successText: that.jsT.T(that.translateWords.successText),
          failText: that.jsT.T(that.translateWords.failText),
          selectText:that.jsT.T(that.translateWords.selectText),
          statusText: that.jsT.T(that.translateWords.statusText),
       
          regionText: that.jsT.T(that.translateWords.regionText),
          loadFail: that.jsT.T(that.translateWords.loadFail),
          loadRegionFail: that.jsT.T(that.translateWords.loadRegionFail),
          loadRoomFail: that.jsT.T(that.translateWords.loadRoomFail),
          delSuccess: that.jsT.T(that.translateWords.delSuccess),
          delfailt: that.jsT.T(that.translateWords.delfailt),
          selectOneRegion: that.jsT.T(that.translateWords.selectOneRegion),
          title:that.jsT.T(that.translateWords.title),
          Save:that.jsT.T(that.translateWords.Save),
          add:that.jsT.T(that.translateWords.add)
          
        };
          this.rules= {
               PositionName: [{ required: true, message: "位置不能为空" }],
          }

      } else {
        console.log("翻译器没有加载成功");
      }
    },   
   
      getcountry() {
      var params = new URLSearchParams();
         params.append("uid", this.uid);
      params.append("cmd", "GetCountry");
      params.append("lang", this.lang);
      this.$http.post(this.actionurl, params).then((res) => {
        this.DepartmentDropList = res.data.Data;
     
      });
    },
    getData(index, size) {
      var params = new URLSearchParams();
      params.append("pageIndex", index);
      params.append("pageSize", size);
       params.append("lang", this.lang);
       params.append("uid", this.uid);
      params.append("cmd", "LoadPosition");
      if (this.isQuery) {
        params.append("PositionName", this.PositionQuery.PositionName);
        params.append("Status", this.PositionQuery.Status);
        params.append("RegionId", this.PositionQuery.RegionId);
         params.append("RegionStatus", this.PositionQuery.RegionStatus);
           params.append("DepartMentID", this.PositionQuery.DepartMentID);
      }
      this.$http.post(this.actionurl, params).then((res) => {
        this.tableData = res.data.Data.list;
        this.total = res.data.Data.total;
      });
    },
    setInitStatus() {
      this.loaddropregion();
      this.getinitstatus();
    },
    loaddropregion:function(){
        var that =this;
      var params = new URLSearchParams()
       params.append("uid", this.uid);
       params.append("lang", this.lang);
        params.append("cmd", "LoadDropRegion");
        this.$http.post(this.actionurl, params)
          .then(res => {
            if (res.data.Message == "") {
               
                this.RegionNameDropList=res.data.Data;
                this.AddRegionNameDropList=res.data.Data;
            }
            else {
              alert(that.translateWords.loadFail);
              console.log(res.data.Message);
            }
          })
    },   
    add()
    {     this.Id=0;
          this.isEdit=false;
          this.ruleForm.PositionName='';
          this.ruleForm.Status=1;
          this.ruleForm.IsUseRegion=1;
          this.ruleForm.RegionId='';
          this.dialogVisible=true;
    },
    getinitstatus() {
      var params = new URLSearchParams();
      params.append("cmd", "GetStatus");
      params.append("lang", this.lang);
      this.$http.post(this.actionurl, params).then((res) => {
        this.PositionStatusDropList = res.data.Data;
         this.AddPositionStatusDropList = res.data.Data;
         this.AddIsUseRegionDropList=res.data.Data;
         this.AddIsUseRegionDropList=res.data.Data;
         this.RegionStatusDropList=res.data.Data;
      });
    },
      submitForm(formName) {
    
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.Status == 0) {
            alert(this.translateWords.statusText);
            return;
          }
          if (this.ruleForm.IsUseRegion == 0) {
            alert(this.translateWords.IsUseRegion);
            return;
          }
           if (this.ruleForm.RegionId == 0) {
            alert(this.translateWords.regionText);
            return;
          }
          var params = new URLSearchParams();
          for (var key in this.ruleForm) {
            params.append(key, this.ruleForm[key]);
          }
            params.append("uid", this.uid);
            params.append("lang", this.lang);
            if(this.isEdit)
            {
                   params.append("Id", this.Id);
                   params.append("cmd", "EditPosition");
            }
            else
            {
                //this.translateWords.title=this.jsT.T("新增位置"),
                params.append("cmd", "SavePosition");
            }
            this.$http.post(this.actionurl, params)
              .then(res => {
                if (res.data.Message == "") {  
                alert(this.translateWords.successText);
                }
                else {
                    alert(this.translateWords.failText+":"+res.data.Message);
                    console.log(res.data.Message);
                }
                this.dialogVisible=false;
                this.getData(1,10);
              })

        }
         else {
          return false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currPage = 1;
      this.getData(this.currPage, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currPage = val;
      this.getData(this.currPage, this.pageSize);
    },
    query() {
      this.isQuery = true;
      this.getData(1, 10);
    },
    handleEdit(index, row) {
     
        this.dialogVisible=true
        this.isEdit=true;
        this.Id=row.Id;
        this.ruleForm.Status=row.StatusCode;
        this.ruleForm.IsUseRegion=row.IsUseRegionCode;
        this.ruleForm.RegionId=row.RegionId;
        this.ruleForm.PositionName=row.PositionName;
    },
    handleDelete(index, row) {
      var that = this;
      var params = new URLSearchParams();
      params.append("id", row.Id);
      params.append("uid", this.uid);
      params.append("lang", this.lang);
      params.append("cmd", "DeletePosition");
      this.$http.post(this.actionurl, params).then((res) => {
        if (res.data.Message == "") {
          alert(that.translateWords.delSuccess);
          this.getData(1, 10);
        } else {
             alert(that.translateWords.delfailt+":"+res.data.Message);
        }
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Position.vue